import { useContext, useMemo } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import { FormHelperText, Grid } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import ContentModalContext from '../../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../../components/constants'
import DateSelector from './DateSelector'
import TimeSelector from './TimeSelector'

const startField = FIELD_NAMES.START_TIME
const endField = FIELD_NAMES.END_TIME
const recurringField = FIELD_NAMES.IS_RECURRING

const DateTimeSelector = () => {
  const { item } = useContext(ContentModalContext)
  const isRecurring = item[recurringField]
  const start = useMemo(() => {
    const val = item[startField]
    if (!val) return val
    return new Date(val)
  }, [item])
  const end = useMemo(() => {
    const val = item[endField]
    if (!val) return val
    return new Date(val)
  }, [item])

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid
        container
        spacing={2}
      >
        {isRecurring ? (
          <Grid
            item
            xs={12}
          >
            <DateSelector label={LABELS.RECURRING_DATE} />
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <DateSelector label={LABELS.DATE} />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TimeSelector
                label={LABELS.START_TIME}
                max={end}
                min={null}
                fieldName={startField}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TimeSelector
                label={LABELS.END_TIME}
                min={start}
                max={null}
                fieldName={endField}
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <FormHelperText>
                If you're scheduling from outside the event's time zone, please note that events you create will be
                based off your computer's local time.
              </FormHelperText>
            </Grid>
          </>
        )}
      </Grid>
    </MuiPickersUtilsProvider>
  )
}

export default DateTimeSelector
